import {deviceType} from './deviceType'
// console.log(deviceType)
export default{
  isApp() {
    if (deviceType.isAndroidApp) {
      console.log('android');
      return "android"
    } else if (deviceType.isIOSApp) {
      return "IOS"
    } else {
      return "H5"
    }
  },
    appData(){
        if(deviceType.isAndroidApp){
            try {
                return JSON.parse(window.app_android_interface.getUserInfo());
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    toAppWeb(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.askDoctor(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    showAppTrBtn(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.showTrBtn(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){

        }
    },
    appSendSurvey(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.sendSurvey(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appVisitSheetSubmit(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.visitSheetSubmit(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){

        }
    },
    appSurveySubmit(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.surveySubmit(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){

        }
    },
    appShare(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.share(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appSendPrescription(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.sendPrescription(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appPay(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.pay(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){

        }
    },
    appSendKffz(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.sendKffz(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appSelectPrescription(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.selectPrescription(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appOpenArchive(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.openArchive(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
          window.webkit.messageHandlers.openArchive.postMessage({
            params: JSON.stringify(data),
          });
        }
    },
    appOpenMiniProgram(data){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.openMiniProgram(JSON.stringify(data));
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appCloseWebView(){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.closeWebView();
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
          window.webkit.messageHandlers.closeWebView.postMessage({});
        }
    },
    appDarkModel(){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.darkModel();
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
            console.log('IOS')
        }
    },
    appCloseLoadingView(){
        if(deviceType.isAndroidApp){
            try {
                window.app_android_interface.closeLoadingView();
            } catch (e) {
                console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
            }
        }else if(deviceType.isIOSApp){
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/appUtils.js